import { TrackJS } from "trackjs";
import { initializeAttribution } from "@nextday/attribution";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "@src/App";
import { TrackJSErrorBoundary } from "@src/TrackJSErrorBoundary";
import "@src/styles.css";

const trackjsToken: string | undefined = import.meta.env.VITE_TRACKJS_TOKEN;
if (trackjsToken) {
  TrackJS.install({
    token: trackjsToken,
    application: "onboarding-funnel",
    onError(payload) {
      // Suppress cross-origin "Script error." from third-party ad scripts —
      // these have no usable stack trace and pollute the dashboard.
      if (payload.message === "Script error." && !payload.stack) return false;
      // Ignore Kinde OAuth 400s (expired sessions, invalid grants) but keep 5xx.
      if (payload.message.includes("/oauth2/token") && payload.message.startsWith("4"))
        return false;
      return true;
    },
  });
}

// Capture click ids + UTM into the attribution envelope before first render.
// Fire-and-forget: the synchronous parts (URL parse + envelope write + URL
// strip) all complete before React commits in practice, and any failure is
// swallowed inside initializeAttribution so it never blocks the funnel.
const adHSigningSecret: string | undefined = import.meta.env.VITE_AD_H_SIGNING_SECRET;
void initializeAttribution(adHSigningSecret);

const rootEl = document.getElementById("root");
if (rootEl) {
  createRoot(rootEl).render(
    <React.StrictMode>
      <TrackJSErrorBoundary>
        <App />
      </TrackJSErrorBoundary>
    </React.StrictMode>,
  );
}
